import { render, staticRenderFns } from "./support-modal.vue?vue&type=template&id=3746fb08&"
import script from "./support-modal.vue?vue&type=script&lang=js&"
export * from "./support-modal.vue?vue&type=script&lang=js&"
import style0 from "./support-modal.vue?vue&type=style&index=0&id=3746fb08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports